import TiktokTab from './TiktokTab';
import TwitterTab from './TwitterTab';
import BilibiliTab from './BilibiliTab';
import DouyinTab from './DouyinTab';

export interface ITabConfigItem {
  key: string;
  label: string;
  component: React.ComponentType<any>;
}

export const TAB_CONFIG: ITabConfigItem[] = [
  { key: 'tiktok', label: 'TikTok', component: TiktokTab },
  { key: 'twitter', label: 'X', component: TwitterTab },
  { key: 'bilibili', label: 'Bilibili', component: BilibiliTab },
  { key: 'douyin', label: 'Douyin', component: DouyinTab },
];

export const DEFAULT_TAB = 'tiktok';
